import type { ComponentProps } from "react";

export function Warning(props: ComponentProps<"svg">) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={20}
			height={20}
			fill="none"
			{...props}
		>
			<circle
				cx={9.997}
				cy={9.997}
				r={7.247}
				stroke="currentColor"
				strokeWidth={1.5}
			/>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeWidth={1.5}
				d="M9.996 10.255V6.506"
			/>
			<circle
				cx={9.997}
				cy={12.603}
				r={0.5}
				stroke="currentColor"
				strokeWidth={0.769}
			/>
		</svg>
	);
}
